import { Option } from '@carvana/ds-popup';
import Select from '@carvana/ds-select';
import TextInput from '@carvana/ds-text-input';
import { useTestFunc } from '@carvana/test-attributes';
import { useState } from 'react';

import { PlateState, InputsWrapper, StateWrapper, ErrorTextContainer } from './PlateEntry.styles';
import usaStates from './usaStates';

type PlateEntryProps = {
  plate: string;
  plateError: boolean;
  error: string;
  onBlur: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  state: string;
  stateError: boolean;
  updatePlate: (target: React.ChangeEvent<HTMLInputElement>) => void;
  updateState: (value: string) => void;
  wideOnDesktop?: boolean;
};

const PlateEntry = ({
  plate,
  plateError = false,
  error,
  onBlur,
  onKeyDown,
  state,
  stateError = false,
  updatePlate,
  updateState,
  wideOnDesktop = false
}: PlateEntryProps) => {
  const getTestAttributes = useTestFunc();
  const [stateTouched, setStateTouched] = useState(false);
  const options = usaStates.map(e => ({ value: e, label: e }));
  const shouldShowError = plateError || error;

  const handleStateBlur = () => {
    setStateTouched(true);
    onBlur?.();
  };

  const handleStateChange = (
    _children: React.ReactNode | React.ReactNode[],
    _event?: React.ChangeEvent<HTMLInputElement> | React.MouseEvent<Element, globalThis.MouseEvent>,
    value?: string | string[]
  ) => {
    if (value && typeof value === 'string') {
      updateState(value);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    onKeyDown?.(e);
  };

  return (
    <PlateState>
      <InputsWrapper>
        <TextInput
          {...getTestAttributes('LicensePlateInput')}
          hasError={plateError}
          id="plate"
          value={plate}
          label="License Plate"
          maxLength={8}
          onChange={updatePlate}
          onKeyDown={handleKeyDown}
          touched={plate?.length > 0}
          width="100%"
          onBlur={onBlur}
        />
        <StateWrapper $wideOnDesktop={wideOnDesktop}>
          <Select
            className="stateStyle"
            label="State"
            value={state}
            onChange={handleStateChange}
            onBlur={handleStateBlur}
            hasError={stateError}
            error="State is required"
            touched={stateTouched}
            options={options}
          >
            {options.map(o => (
              <Option key={o.label} value={o.label}>
                {o.label}
              </Option>
            ))}
          </Select>
        </StateWrapper>
      </InputsWrapper>
      {shouldShowError && error && <ErrorTextContainer>{error}</ErrorTextContainer>}
    </PlateState>
  );
};

export default PlateEntry;
